import { render } from "./admin-voice-of-god.svg?vue&type=template&id=d19a9f26"
const script = {}
script.render = render

export default script